import { useEffect, useState } from "react"
import CloseIcon from "../../icons/CloseIcon"
import SongItemBeta from "../../shared/components/SongItemBeta"
import groupBySong from "../../shared/utils/songNormalizer"

import { ApolloProvider } from "@apollo/client"

const PlayHistoryContainer = ({ closeHistoryCallback, user_role }) => {
  const [songs, setSongs] = useState([])
  const [expandedSongVersionId, setExpandedSongVersionId] = useState(false)
  const handleSetExpandedSongVersionId = (svid) => {
    setExpandedSongVersionId(svid)
  }


  const handleFetchHistory = async () => {
    // TODO: the audio player controller is fetching the history items, so this is a duplicate request.
    // It's going to require a refactor to get the history items from the audio player controller in the correct format.
    const response = await fetch("/api/v1/users/get_play_history", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      throw new Error("Failed to fetch play history")
    }

    return await response.json()
  }

  useEffect(() => {
    const handleCustomEvent = (payload) => {
      const { show } = payload.detail

      if (show) {
        const res = handleFetchHistory()
        res.then((json) => {
          const songs = json?.data?.map((song) => song.detail)
          const normalizedSongs = groupBySong(songs)
          setSongs(normalizedSongs)
        })
      }
    }

    window.addEventListener("playerHistory", handleCustomEvent)

    return () => {
      window.removeEventListener("playerHistory", handleCustomEvent)
    }
  }, [])

  const songVersionProps = {
    song_versions_count: 1,
    user_role,
    handleSetExpandedSongVersionId,
    expandedSongVersionId,
  }

  return (
    <div className="wrap">
      <div className="contain">
        <header>
          <h5 className="hFive">History</h5>
          <a data-prevent-default className="close-history" onClick={closeHistoryCallback}>
            <CloseIcon />
          </a>
        </header>
        <section className="mm-player-history-list" aria-label="desktop player history list">
          <ol className="mm-song-versions-table">
            <li className="mm-song-versions-table-head">
              <ol>
                <li className="song-version">Song / Artist</li>
                <li className="versions desktop">Versions</li>
                <li className="genres desktop">Genres</li>
                <li className="arc desktop">Arc&trade;</li>
                <li className="energy desktop" data-touch>
                  Energy
                </li>
                <li className="length">Length</li>
              </ol>
            </li>
            {songs && (
              <div className="mm-song-versions-table-list">
                <ApolloProvider client={window.Stimulus.apolloClient}>
                  {songs.map((song, idx) => (
                    <SongItemBeta
                      song={song}
                      {...songVersionProps}
                      key={song.songVersions[0].id + idx}
                    />
                  ))}
                </ApolloProvider>
              </div>
            )}
          </ol>
        </section>
      </div>
    </div>
  )
}

export default PlayHistoryContainer
